module.exports = __webpack_public_path__ + "i18n/es_c6f6d57ed53517e31c678cd56175b600.json";


//////////////////
// WEBPACK FOOTER
// ./app/assets/i18n/es.json
// module id = +lAx
// module chunks = 151